var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallSuitcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 45,
    viewBox: "0 0 44 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31 23.755C28.1405 24.9112 25.0844 25.5038 22 25.5C18.817 25.5 15.78 24.88 13 23.755M22 22.5H22.01M26 16.5V14.5C26 13.9696 25.7893 13.4609 25.4142 13.0858C25.0391 12.7107 24.5304 12.5 24 12.5H20C19.4696 12.5 18.9609 12.7107 18.5858 13.0858C18.2107 13.4609 18 13.9696 18 14.5V16.5H26ZM15 30.5H29C29.5304 30.5 30.0391 30.2893 30.4142 29.9142C30.7893 29.5391 31 29.0304 31 28.5V18.5C31 17.9696 30.7893 17.4609 30.4142 17.0858C30.0391 16.7107 29.5304 16.5 29 16.5H15C14.4696 16.5 13.9609 16.7107 13.5858 17.0858C13.2107 17.4609 13 17.9696 13 18.5V28.5C13 29.0304 13.2107 29.5391 13.5858 29.9142C13.9609 30.2893 14.4696 30.5 15 30.5Z",
    stroke: "#FF5F14",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallSuitcase);
export default __webpack_public_path__ + "static/media/smallSuitcase.334875544e3f1c3316580576b6b4f10c.svg";
export { ForwardRef as ReactComponent };